import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Typography, Form, Input, Row, Col, Icon } from 'antd'
import { changeFormatdateSlip } from '../../../../../utils/formatdate'
import moment from 'moment'
import { Link } from 'react-router-dom'

const { Text, Title } = Typography


class SentNoteApproveMeeting extends Component {
	state = {
	}
	cardBox = (dataMeeting) => {
		let content = [];
		for (let index = 1; index <= dataMeeting.length; index++) {
			content.push(
				<Col span={24} className={"box-show-meeting p-3 my-3"}>
					<p>{dataMeeting[index].subject}</p>
				</Col>
			);
		}
		return content;
	}
	render() {
		const { dataMeeting } = this.props
		const { getFieldDecorator } = this.props.form;
		return (
			<Row gutter={16} >
				{/* {this.cardBox(dataMeeting)} */}

				{dataMeeting && dataMeeting.length > 0 ?
					dataMeeting.map((MeetingList, i) => {
						return (
							<>
								{(MeetingList.Summaries).length == 0 ?
									<Col span={24} className={"box-show-meeting p-3 my-3"} >
										<Row gutter={16}>
											<Col span={17}>
												<p className={"text-box-meeting"}><Icon className="icon-box-meeting" type="sound" />{MeetingList.subject}</p>
											</Col>
											<Link
												to={{
													pathname: `/meetingmanagement/waitMeeting/sentNoteMeetingForm`,
													search: 'id=' + MeetingList.id + '&status=sentnote&from=/meetingmanagement/waitMeeting',
												}}>
												<Col span={7} align="end">
													<Icon type="right" style={{ color: "#666666" }} />
												</Col>
											</Link>
											<Col span={17}>
												<p className={"text-box-meeting"}><Icon className="icon-box-meeting" type="clock-circle" />{changeFormatdateSlip(moment(MeetingList.startDate))} / {moment(MeetingList.startDate).format('HH:ss')} - {moment(MeetingList.endDate).format('HH:ss')} น.</p>
											</Col>
											<Col span={7}>

											</Col>
											<Col span={17}>
												<p className={"text-box-meeting"}><Icon className="icon-box-meeting" type="environment" />{MeetingList.location}</p>
											</Col>
											<Col span={7} align="end">
												<p className={"text-box-meeting"} style={{ color: "#FDB75D" }}>ยังไม่ได้ส่ง</p>
											</Col>
										</Row>
									</Col>
									:
									<Col span={24} className={"box-show-meeting p-3 my-3"} style={{ backgroundColor: "#F5F5F5" }}>
										<Row gutter={16}>
											<Col span={17}>
												<p className={"text-box-meeting"}><Icon className="icon-box-meeting" type="sound" />{MeetingList.subject}</p>
											</Col>
											<Link
												to={{
													pathname: `/meetingmanagement/waitMeeting/sentNoteMeetingForm`,
													search: 'id=' + MeetingList.id + '&status=sentnote&from=/meetingmanagement/waitMeeting',
												}}>
												<Col span={7} align="end">
													<Icon type="right" style={{ color: "#666666" }} />
												</Col>
											</Link>
											<Col span={17}>
												<p className={"text-box-meeting"}><Icon className="icon-box-meeting" type="clock-circle" />{changeFormatdateSlip(moment(MeetingList.startDate))} / {moment(MeetingList.startDate).format('HH:ss')} - {moment(MeetingList.endDate).format('HH:ss')} น.</p>
											</Col>
											<Col span={7}>

											</Col>
											<Col span={17}>
												<p className={"text-box-meeting"}><Icon className="icon-box-meeting" type="environment" />{MeetingList.location}</p>
											</Col>
											<Col span={7} align="end">
												<p className={"text-box-meeting"} style={{ color: "#178991" }}>ส่งแล้ว</p>
											</Col>
										</Row>
									</Col>
								}
							</>
						)
					})
					:
					<Col xs={24} md={24} align={"center"} style={{ marginTop: "150px" }}>
						<Text>ไม่พบข้อมูล</Text>
					</Col>}
				<Col xs={{ span: 24, offset: 0 }}>
					{/*{dataMeeting}*/}
				</Col>
			</Row>
		)
	}
}


SentNoteApproveMeeting.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedAddMeeting = Form.create()(SentNoteApproveMeeting)

export default withApollo(WrappedAddMeeting)